import React, { useState, useEffect } from 'react';
import { Html } from '@react-three/drei';
import { useInfoCardState } from './useInfoCardState';

// ─── Mode 3: Screen Space (2D overlay, anchored to 3D point) ────────────────

const InfoCardScreen: React.FC = () => {
    const { selection, cardPos } = useInfoCardState();
    const [visible, setVisible] = useState(false);
    const [testColor, setTestColor] = useState('#3b82f6');

    useEffect(() => {
        if (selection) {
            setVisible(false);
            const t = setTimeout(() => setVisible(true), 100);
            return () => clearTimeout(t);
        }
        setVisible(false);
    }, [selection?.index]);

    if (!selection) return null;

    return (
        <group position={selection.position}>
            <Html
                position={cardPos}
                zIndexRange={[1000, 0]}
                style={{
                    transition: 'all 0.3s ease',
                    opacity: visible ? 1 : 0,
                    pointerEvents: visible ? 'auto' : 'none',
                }}
            >
                <div onPointerDown={e => e.stopPropagation()} style={{
                    background: 'rgba(10,15,30,0.9)', border: `1px solid ${testColor}40`,
                    borderRadius: '6px', padding: '8px 10px', width: '160px',
                    fontFamily: 'Inter, system-ui, sans-serif', color: '#cbd5e1', fontSize: '11px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.6)',
                }}>
                    <div style={{ fontWeight: 600, color: '#f1f5f9', fontSize: '12px', marginBottom: '4px', wordBreak: 'break-all' }}>
                        {selection.info?.filename ?? `Particle #${selection.index}`}
                    </div>
                    {selection.info && (
                        <div style={{ color: '#94a3b8', display: 'flex', gap: '8px', marginBottom: '6px' }}>
                            <span>{selection.info.fileSize} KB</span>
                            <span>{selection.info.extension}</span>
                            <span>{selection.info.format}</span>
                        </div>
                    )}
                    <div style={{ display: 'flex', gap: '4px' }}>
                        <button onClick={() => setTestColor('#ef4444')} style={{ background: '#ef4444', border: 'none', width: 18, height: 18, borderRadius: 3, cursor: 'pointer' }} />
                        <button onClick={() => setTestColor('#22c55e')} style={{ background: '#22c55e', border: 'none', width: 18, height: 18, borderRadius: 3, cursor: 'pointer' }} />
                        <button onClick={() => setTestColor('#3b82f6')} style={{ background: '#3b82f6', border: 'none', width: 18, height: 18, borderRadius: 3, cursor: 'pointer' }} />
                    </div>
                </div>
            </Html>
        </group>
    );
};

export default InfoCardScreen;
